/** Respuesta de presignado para subir archivos a S3. */
export interface IPresignFileResponse {
  uploadUrl: string;
  fileUrl: string;
  key: string;
}

export class PresignFileResponse {
  uploadUrl: string;
  fileUrl: string;
  key: string;

  constructor(data: IPresignFileResponse) {
    this.uploadUrl = data.uploadUrl;
    this.fileUrl = data.fileUrl;
    this.key = data.key;
  }
}

/**
 * Tipos MIME que acepta el presignado del API. `image/jpg` no es un MIME real
 * pero el API lo admite, y algunos navegadores lo emiten, asi que va en la
 * lista.
 */
export const ALLOWED_CONTENT_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
] as const;

/** Extensiones equivalentes, para el atributo `accept` del input file. */
export const ALLOWED_FILE_ACCEPT = '.jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf';

/** Tope de tamano del archivo: 5 MB. */
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

/**
 * Valida tipo y tamano en el cliente ANTES de pedir el presignado: la URL
 * firmada vive 300 s y no conviene gastarla en un archivo que S3 rechazaria.
 *
 * Devuelve el mensaje de error en espanol, o `null` si el archivo es valido.
 */
export const validateUploadFile = (file: File): string | null => {
  const contentType = (file.type || '').toLowerCase();

  if (!ALLOWED_CONTENT_TYPES.includes(contentType as (typeof ALLOWED_CONTENT_TYPES)[number])) {
    return 'Formato no permitido. Usa JPG, PNG o PDF.';
  }

  if (file.size > MAX_FILE_SIZE_BYTES) {
    return 'El archivo supera el limite de 5 MB.';
  }

  if (file.size === 0) {
    return 'El archivo esta vacio.';
  }

  return null;
};

/** True si el MIME corresponde a una imagen previsualizable. */
export const isPreviewableImage = (contentType: string | null | undefined): boolean =>
  !!contentType && contentType.toLowerCase().startsWith('image/');
